import InsList from './InsList'
import InsCreate from './InsCreate'
import Edit from './InsEdit'

export default {
    list: InsList,
    edit: Edit,
    create: InsCreate,
};
